var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon library/fi-rs-comment-info",
    clipPath: "url(#clip0_405_2261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.875 3.79167C7.875 3.96473 7.82369 4.1339 7.72754 4.27779C7.63139 4.42169 7.49474 4.53384 7.33485 4.60006C7.17497 4.66629 6.99903 4.68362 6.8293 4.64986C6.65957 4.61609 6.50366 4.53276 6.38128 4.41039C6.25891 4.28802 6.17558 4.13211 6.14182 3.96237C6.10805 3.79264 6.12538 3.61671 6.19161 3.45682C6.25783 3.29694 6.36999 3.16028 6.51388 3.06413C6.65777 2.96799 6.82694 2.91667 7 2.91667C7.23207 2.91667 7.45463 3.00886 7.61872 3.17295C7.78282 3.33705 7.875 3.55961 7.875 3.79167ZM14 7C14 5.61553 13.5895 4.26216 12.8203 3.11101C12.0511 1.95987 10.9579 1.06266 9.67879 0.532846C8.3997 0.003033 6.99224 -0.13559 5.63437 0.134506C4.2765 0.404603 3.02922 1.07129 2.05026 2.05026C1.07129 3.02922 0.404603 4.2765 0.134506 5.63437C-0.13559 6.99224 0.003033 8.3997 0.532846 9.67879C1.06266 10.9579 1.95987 12.0511 3.11101 12.8203C4.26216 13.5895 5.61553 14 7 14H14V7ZM12.8333 7V12.8333H7C5.84628 12.8333 4.71846 12.4912 3.75918 11.8502C2.79989 11.2093 2.05222 10.2982 1.61071 9.23232C1.16919 8.16642 1.05368 6.99353 1.27876 5.86198C1.50384 4.73042 2.05941 3.69102 2.87521 2.87521C3.69102 2.05941 4.73042 1.50384 5.86198 1.27876C6.99353 1.05368 8.16642 1.16919 9.23232 1.61071C10.2982 2.05222 11.2093 2.79989 11.8502 3.75918C12.4912 4.71846 12.8333 5.84628 12.8333 7ZM8.16667 7C8.16667 6.69058 8.04375 6.39384 7.82496 6.17505C7.60617 5.95625 7.30942 5.83334 7 5.83334H5.83334V7H7V11.0833H8.16667V7Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_2261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentInfo);
export default __webpack_public_path__ + "static/media/comment-info.76f66e52f58e4c4f5b15774e00fc217c.svg";
export { ForwardRef as ReactComponent };